import axios from 'axios';
import Cookies from 'js-cookie';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost/api', 
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }
});

/**
 * Função para buscar o Cookie CSRF do Laravel Sanctum
 */
api.getCsrfCookie = async () => {
    try {
        // Pega a URL da API e garante que aponte para o subdomínio api.
        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost/api';
        const rootUrl = apiUrl.endsWith('/api') ? apiUrl.slice(0, -4) : apiUrl;
        
        // Chamada direta para o subdomínio da API
        await axios.get(`${rootUrl}/sanctum/csrf-cookie`, {
            withCredentials: true,
        });

        const token = Cookies.get('XSRF-TOKEN');
        if (!token) {
            throw new Error('CSRF token ausente');
        }
        return token;
    } catch (error) {
        console.error('Erro ao obter o token CSRF:', error);
        throw error;
    }
};

/**
 * Interceptor para injetar o Token CSRF em mutações (POST, PUT, DELETE)
 */
api.interceptors.request.use(async (config) => {
    const methodsToProtect = ['post', 'put', 'patch', 'delete'];

    if (methodsToProtect.includes(config.method?.toLowerCase() || '')) {
        let xsrfToken = Cookies.get('XSRF-TOKEN');

        if (!xsrfToken) {
            try {
                await api.getCsrfCookie();
                xsrfToken = Cookies.get('XSRF-TOKEN');
            } catch (error) {
                console.error('Falha ao recuperar CSRF para a requisição:', error);
            }
        }

        if (xsrfToken) {
            // Decodifica para garantir que o Laravel aceite o token localmente
            config.headers['X-XSRF-TOKEN'] = decodeURIComponent(xsrfToken);
        }
    }

    return config;
});

/**
 * Troca de Polo
 */
api.switchPolo = async (poloId) => {
    try {
        const response = await api.post('/switch-polo', { polo_id: poloId });
        return response.data;
    } catch (error) {
        console.error('Erro ao trocar polo:', error);
        return false;
    }
};

/**
 * Upload de Foto de Aluno
 */
api.uploadPhoto = async (studentId, photoFile) => {
    const formData = new FormData();
    formData.append('photo', photoFile);
    
    return api.post(`/student/${studentId}/upload-photo`, formData, {
        headers: { 
            'Content-Type': 'multipart/form-data' 
        }
    });
};

export default api;